/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const QuantityValueType = {
    FloatingPoint: 'FloatingPoint',
    IntegerNumber: 'IntegerNumber'
} as const;
export type QuantityValueType = typeof QuantityValueType[keyof typeof QuantityValueType];


export function QuantityValueTypeFromJSON(json: any): QuantityValueType {
    return QuantityValueTypeFromJSONTyped(json, false);
}

export function QuantityValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuantityValueType {
    return json as QuantityValueType;
}

export function QuantityValueTypeToJSON(value?: QuantityValueType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the QuantityValueType interface.
 */
 export function instanceOfQuantityValueType(value: any): value is QuantityValueType {
    return Object.values(QuantityValueType).includes(value)
}

